import { React, useContext, useEffect, useRef, useState } from 'react';
import {
  Button,
  Text,
  HStack,
  Box,
  Grid,
  GridItem,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  VStack,
  Flex,
  Divider,
  ButtonGroup,
  Spacer,
  useToast,
} from '@chakra-ui/react';
import { CiWarning } from 'react-icons/ci';
import { Form, Formik } from 'formik';
import { useNavigate, useLocation } from 'react-router';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import socketIOClient from 'socket.io-client';
import { AccountContext } from 'components/AccountContext';
// import sendMessageSolicitante from './sendMessageSolicitante';
import WarningIcon from '../../images/WarningBranco.svg';
import { ReactComponent as CheckCircle } from '../../images/check-circle.svg';
import { api } from 'api/api';
import { GiPadlock } from 'react-icons/gi';
import { IoWarning } from 'react-icons/io5';
import { FaRegCopy } from 'react-icons/fa6';
import Clube from '../../images/dashboard/estrelaAzul.svg';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
const REACT_APP_DEOVITA_RECIPIENT_ID =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_DEOVITA_RECIPIENT_ID_PROD
    : process.env.REACT_APP_DEOVITA_RECIPIENT_ID_TEST;

const VINDI_AFFILIATE_DEOVITA_ID = parseInt(
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_VINDI_AFFILIATE_DEOVITA_ID_PROD
    : process.env.REACT_APP_VINDI_AFFILIATE_DEOVITA_ID_TEST,
  10
) || null;

const PixGenerico = (selecionado) => {
  const valorParcelas = selecionado.valorParcelas;
  const valor_selecionado = selecionado.selecionado;
  const mdvPercent = selecionado.mdvPercent ?? 0;
  const mdvGerente = selecionado.mdvGerente ?? 0;
  const mdvDiretor = selecionado.mdvDiretor ?? 0;
  const { state } = useLocation();

  const { user } = useContext(AccountContext);
  const expiration_pix_in_min = 30;
  const { navig_to, split, valor_telemedicina } = state;
  const voucher = state?.voucher?.voucher;
  const tipo_voucher = state?.voucher?.tipo;
  const fromCadastro = navig_to === '/cadastro/analise' ? true : false;

  const valor = fromCadastro ? valor_selecionado : state.valor_plano;
  const navigate = useNavigate();
  const [pix, setPix] = useState({ sucess: '', pix_code: '', id: 0, paid: false });
  const [copy, setCopy] = useState(false);
  const [error, setError] = useState(null);
  const [socket] = useState(socketIOClient(ENDPOINT));
  const [timer, setTimer] = useState(60 * 30);
  const intervalRef = useRef();


  const toast = useToast();

  const decreaseTimer = () =>
    setTimer((prev) => {
      if (prev > 0) {
        return prev - 1;
      } else {
        return prev;
      }
    });

  const fromCadastroData = {
    client_id: state.client_id,
    nome: state.name,
    fone: user.phone1 ? user.phone1 : state.phone,
    adicionais: state.adicionais,
    plano: state.id_plano,
  };
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  useEffect(() => {
    socket.on('retorno_pix', (response) => {
      if (response === true) {
        console.log('pix pago');
      }
    });
    let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
    if (user.titular === false) usuarioAssinante = true;

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        particular: !usuarioAssinante ? true : false,
        metadataCoparticipacao: state?.metadataCoparticipacao,
        coparticipacao: user?.allowsTelemedicina?.paga_telemedicina ? user?.allowsTelemedicina?.paga_telemedicina : false,
        id_cliente: user.id_cliente_deovita ? user.id_cliente_deovita : state.client_id,
        nome_cliente: user.name ? user.name : state.name,
        document: user.username ? user.username : state.cpf,
        email: user.email ? user.email : 'novoassinante@deovita.com.br',
        phone: user && user.loggedIn === true ? (user.phone1 ? onlyNumbers(user.phone1) : onlyNumbers(user.phone2)) : state.phone,
        amount: valor_selecionado * 100,
        expiration_in_min: expiration_pix_in_min,
        paid: false,
        frequencia: state.frequencia,
        valorParcelas: valorParcelas,
        valorExtraPsicologo: state?.item?.valorExtraPsicologo,
        valor_extra_psicologo: valor_selecionado,
        split_rules:
          tipo_voucher === 'Vendedor'
            ? voucher
              ? voucher.recipient_id_vindi_gerente
                ? [
                    { amount: mdvGerente, affiliate_id: parseInt(voucher.recipient_id_vindi_gerente), amount_type: 'percentage' },
                    { amount: mdvDiretor, affiliate_id: parseInt(voucher.recipient_id_vindi_diretor), amount_type: 'percentage' },
                    { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                    { amount: 100 - mdvPercent - mdvDiretor - mdvGerente, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' },
                  ]
                : voucher.recipient_id_vindi_diretor
                  ? [
                      { amount: mdvDiretor, affiliate_id: parseInt(voucher.recipient_id_vindi_diretor), amount_type: 'percentage' },
                      { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                      { amount: 100 - mdvPercent - mdvDiretor, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' },
                    ]
                  : [
                      { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                      { amount: 100 - mdvPercent, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' },
                    ]
              : split
            : split,
        item: fromCadastro === true ? fromCadastroData : state.item,
        voucher: tipo_voucher === 'Vendedor' ? voucher : null,
        otherVoucher: tipo_voucher === 'Vendedor' ? null : voucher,
        settle_the_debt_payment_view: state?.settle_the_debt_payment_view,
      }),
    };

    const erroMsg = 'Não foi possível gerar seu código pix no momento';
    api(`${ENDPOINT}/payment/${state.service}/pix`, requestOptions)
      .catch((err) => {
        console.log('err', err);
        setError(erroMsg);
        return;
      })
      .then(async (res) => {
        if (!res || !res.ok || res.status >= 400) {
          const errorData = await res.json().catch(() => ({})); 
          if(errorData[0]){
            setError(errorData[0]);
            if(errorData[0] === 'Não é possível gerar pagamento para esse horário'){
              toast({
                title: 'Essa agenda não está mais disponível',
                description: 'Escolha um outro horário',
                position: 'bottom',
                duration: 6000,
                isClosable: true,
                status: 'warning',
                colorScheme: 'red',
                type: 'loading',
                containerStyle: {
                  paddingTop: '50px',
                },
              });
              navigate(-2);
              return;
            }
            if(errorData[0] === 'Agendamento já faturado'){
              navigate(navig_to, {
                state: {
                  ...state,
                  valor: valor,
                  transaction_id: pix.id,
                  forma_pgto: 'pix',
                  pix_code: pix.pix_code,
                  credito_id: pix.credito_id,
                  metadataCoparticipacao: state?.metadataCoparticipacao,
                  coparticipacao: user?.allowsTelemedicina?.paga_telemedicina,
                },
              });
              return;
            }
            if(errorData[0] === 'Horário não está mais disponível'){
              toast({
                title: 'Horário não está mais disponível',
                description: 'Escolha um outro horário',
                position: 'bottom',
                duration: 6000,
                isClosable: true,
                status: 'warning',
                colorScheme: 'red',
                type: 'loading',
                containerStyle: {
                  paddingTop: '50px',
                },
              });
              navigate(-2);
              return;
            }
            return;
          }
          console.log('res', res.body);
          setError(erroMsg);
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (!data) return;
        if (data.sucess === false && data.message === 'Já existe um contrato para esse paciente') {
          navigate('/alerts/sucesso/cadastro_contrato/');
        }
        if (data.sucess) {
          setError(null);
          socket.emit('pix', { duration: 5 * 60, id: data.id });
          setPix({ ...data, paid: false });
          // if (state.solicitacao === true) {
          //   console.log('sending message');
          //   sendMessageSolicitante(ENDPOINT, state.orcamento_id);
          // }
        } else {
          setError(erroMsg);
        }
      });
  }, []);

  useEffect(() => {
    if (pix.pix_code) {
      intervalRef.current = setInterval(decreaseTimer, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [pix]);

  function renderPixPaid() {
    return (
      <Modal isOpen={true} isCentered>
        <ModalOverlay />
        <ModalContent p={8} bgColor={'#F3F3F3'} borderRadius={10} color={'#585858'} m={4}>
          <CheckCircle width={25} height={25}></CheckCircle>
          <Text mt={4} fontWeight={'bold'} fontSize={20}>
            Seu <span style={{ color: '#5AB2AE' }}>pagamento</span> foi realizado <span style={{ color: '#5AB2AE' }}>com sucesso!</span>
          </Text>
          <Text mt={4}>Ficamos felizes por escolher o DeoVita! Você será redirecionado para a Home do app.</Text>

          <Button isFullWidth colorScheme="teal" onClick={() => navigate('/')} mt={6}>
            Continuar
          </Button>
        </ModalContent>
      </Modal>
    );
  }
  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  const planoNome = state.nome_plano ? state.nome_plano : user?.descricao_plano;
  const isConsulta = state.service === 'telemedicine_deovita' || state.service === 'telemedicine_deovita_pet' || state.service === 'credit';
  let podeOferecerAssinatura = state.service !== 'contract' && ((user.titular === true && !user?.id_contrato) || (!user.titular && !user?.id_plano));

  const voucherConsulta = () => {
    if (voucher) {
      console.log('voucher', voucher);
      return (
        <>
          <HStack justify="space-between" mb={2}>
            <HStack spacing={2} align="center" justify="center">
              <Text fontSize="xs" color="#616161" fontWeight="semibold">
                Voucher {voucher.voucher}
              </Text>
            </HStack>
            {tipo_voucher !== 'Vendedor' && (
              <Text fontSize="xs" fontWeight="bold" color="#2A918A">
                - R$ {state.valorEconomizado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Text>
            )}
          </HStack>
        </>
      );
    }
    return null;
  };
  const valor_original =
    state.service === 'contract'
      ? !usuarioAssinante && state?.valor_com_desconto
        ? state.valor_com_desconto
        : valor_selecionado
      : isConsulta
        ? valor_telemedicina
        : valor_selecionado;

  let valor_original_formatado;

  if (state.service === 'contract' && voucher && tipo_voucher !== 'Vendedor') {
    valor_original_formatado = Number(state.valor_original).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  } else {
    if (typeof valor_original === 'string' && valor_original.includes('R$')) {
      valor_original_formatado = valor_original;
    } else {
      valor_original_formatado = Number(valor_original).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }
  }

  function renderPix() {
    return (
      <>
        <Box bgColor="white" borderRadius="1em" p={4} color="#585858" boxShadow="lg">
          <Text fontSize="xl" textAlign="center" fontWeight="bold" mb={4}>
            Chave Pix
          </Text>
          <Text mb={2}>Pix Copia e Cola:</Text>
          <Box bgColor="#FAFAFA" borderRadius={10} px={3} py={2} mb={2}>
            <Text fontSize="sm" noOfLines={1} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              {pix.pix_code ? pix.pix_code : 'Carregando...'}
            </Text>
          </Box>

          <Flex justify="flex-end">
            <CopyToClipboard text={pix.pix_code} onCopy={() => setCopy(true)}>
              <Button
                colorScheme="teal"
                fontSize={{ base: '0.9rem', md: '1rem' }}
                px={4}
                py={2}
                borderRadius="full"
                whiteSpace="normal"
                lineHeight="1.2"
                disabled={!pix.pix_code}
              >
                {copy ? 'Copiado' : 'Copiar código'} <FaRegCopy style={{ marginLeft: '8px' }} />
              </Button>
            </CopyToClipboard>
          </Flex>
          <VStack spacing={2} mb={2} p={2}>
            <Text
              textAlign={'center'}
              align="right"
              fontSize={18}
              fontWeight={'bold'}
              bg={'#5AB2AE'}
              color={'white'}
              p={2}
              borderRadius={10}
              w="100%"
              maxW={'80px'}
            >
              {`${Math.floor(timer / 60)
                .toString()
                .padStart(2, '0')}:${(timer % 60).toString().padStart(2, '0')}`}
            </Text>
            <Text fontSize={14}>
              Utilize a chave aleatória <br />
              antes do fim deste tempo
            </Text>
          </VStack>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={2}
          mb={2}
          bg="linear-gradient(90deg, #E1F1F1 0%, #FFFFFF 100%)"
          borderRadius="1em"
          p={2}
        >
          <Box display="flex" alignItems="center" gap={3}>
            <Box display="flex" alignItems="center" justifyContent="center" bg="#E0E0E0" borderRadius="full" p={2}>
              <GiPadlock size={22} color="#5AB2AE" />
            </Box>
            <Box>
              <Text color="#616161" fontWeight="bold">
                Pagamento 100% Seguro
              </Text>
              <Text color="#5AB2AE">Seus dados estão protegidos.</Text>
            </Box>
          </Box>
        </Box>
        <Box
          mt={4}
          p={4}
          bg="linear-gradient(90deg, #F9F2E2 0%, #F2DDB5 50%, #F9F2E2 100%)"
          borderRadius={10}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          border="1px solid #f3ddb6"
        >
          <IoWarning color="#C96F1B" size={30} />
          <Text fontSize={12} lineHeight={1.2} textAlign="center" color="#C96F1B">
            O débito será automaticamente processado ao concluir a transação!
          </Text>
        </Box>

        <Box w="100%" border="1px solid #EDEDED" borderRadius="lg" p={4} my={2} bg="white" boxShadow="xs">
          <Text fontSize="sm" fontWeight="bold" color="#424242" mb={2}>
            Resumo do Pedido
          </Text>

          <HStack justify="space-between" align="flex-start" mb={1}>
            <Box>
              <Text fontSize="sm" color="#616161" fontWeight="semibold">
                {state.frequenciaText}
              </Text>
              {state?.service === 'contract' && (
                <>
                  <Text
                    display="inline-block"
                    textAlign="center"
                    fontSize="0.7em"
                    color="#616161"
                    fontWeight="semibold"
                    bg="#EEEEEE"
                    px={2}
                    py={1}
                    borderRadius={5}
                    mt={1}
                  >
                    {state?.plano_anual ? 'Anual' : 'Mensal'}
                  </Text>
                </>
              )}
            </Box>

            <Text fontSize="sm" fontWeight="bold" color="#424242">
              {valor_original_formatado}
            </Text>
          </HStack>

          {!usuarioAssinante && state?.valor_assinante && (
            <HStack justify="space-between" mb={2}>
              <HStack spacing={2} align="center" justify="center">
                <Text fontSize="xs" color="#616161" fontWeight="semibold">
                  Assine e economize!
                </Text>
                <Image src={Clube} alt="Clube de Vantagens" h={3} />
              </HStack>
              <Text fontSize="xs" fontWeight="bold" color="#2A918A">
                {Number(state.valor_assinante).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Text>
            </HStack>
          )}

          {voucherConsulta()}

          <Divider my={2} />

          <HStack justify="space-between">
            <Text fontSize="sm" fontWeight="bold" color="#424242">
              Valor total:
            </Text>

            <Text fontSize="sm" fontWeight="bold" color="#2A918A">
              {Number(!usuarioAssinante && state?.valor_com_desconto ? state.valor_com_desconto : valor_selecionado).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Text>
          </HStack>
        </Box>
      </>
    );
  }

  return (
    <>
      <Formik validateOnChange={false} validateOnBlur={false}>
        <Form>{pix.paid ? renderPixPaid() : renderPix()}</Form>
      </Formik>
      <Button
        backgroundColor={podeOferecerAssinatura ? '#EEEEEE' : '#5AB2AE'}
        color={podeOferecerAssinatura ? '#424242' : '#FFF'}
        w="100%"
        fontSize="sm"
        loadingText="Carregando"
        mt={4}
        borderRadius={'full'}
        isDisabled={!pix.pix_code}
        onClick={() => {
          const pixMsgKey = `wpp_msg_enviada_${pix.id}`;
          if (!localStorage.getItem(pixMsgKey)) {
            api(`${ENDPOINT}/whatsapp/processa-pagamento`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                nome: state.name ? state.name : state.item.nome,
                numero: user.phone1 ? user.phone1 : state.phone ? state.phone : state.item.fone,
                username: user.username ? user.username : state.cpf ? state.cpf : null,
              }),
            });
            localStorage.setItem(pixMsgKey, 'true');
          }
          if (state.service === 'credit') {
            navigate('/telemedicina-loading-pagamento', { state });
            return;
          }
          navigate(navig_to, {
            state: {
              ...state,
              valor: valor,
              transaction_id: pix.id,
              forma_pgto: 'pix',
              pix_code: pix.pix_code,
              credito_id: pix.credito_id,
              metadataCoparticipacao: state?.metadataCoparticipacao,
              coparticipacao: user?.allowsTelemedicina?.paga_telemedicina,
            },
          });
        }}
      >
        <Box w="100%" maxW="100%" overflow="hidden" textOverflow="ellipsis">
          Continuar {podeOferecerAssinatura ? 'sem economizar' : ''}
        </Box>
      </Button>
      {podeOferecerAssinatura && (
        <>
          <Button
            backgroundColor={'#5AB2AE'}
            color="#FFF"
            w="100%"
            fontSize="sm"
            loadingText="Carregando"
            borderRadius={'full'}
            mt={4}
            type="button"
            onClick={() => {
              navigate('/cadastro/plano');
            }}
          >
            Assine e economize
          </Button>
        </>
      )}
      <Spacer mb={10} />
    </>
  );
};

export default PixGenerico;
